import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

function useQuery() {
  const { search } = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}

function setParamList(params, name, value, multi = false) {
  const current = params.get(name)
  if (!multi) {
    if (!value) {
      params.delete(name)
    } else {
      params.set(name, value)
    }
    return
  }
  const list = (current ? current.split(',') : []).filter(Boolean)
  const idx = list.indexOf(value)
  if (idx >= 0) {
    list.splice(idx, 1)
  } else {
    list.push(value)
  }
  if (list.length) params.set(name, list.join(','))
  else params.delete(name)
}

function Filters() {
  const params = useQuery()
  const navigate = useNavigate()

  const toggle = (name, value, multi = false) => {
    const next = new URLSearchParams(params.toString())
    setParamList(next, name, value, multi)
    next.delete('page') // reset page on filter change
    navigate({ search: `?${next.toString()}` }, { replace: false })
  }

  const isChecked = (name, value) => {
    const current = params.get(name)
    if (!current) return false
    return current.split(',').includes(value)
  }

  const reset = () => {
    navigate({ search: '' })
  }

  return (
    <aside className="ws-filters">
      <h5>Filters</h5>

      <div className="ws-filter-group">
        <div className="ws-filter-title">Category</div>
        <ul className="ws-filter-list">
          <li><input type="radio" name="cat" checked={!params.get('category')} onChange={() => toggle('category', '')}/> <span>All</span></li>
          <li><input type="radio" name="cat" checked={params.get('category')==='Full Lace Wigs'} onChange={() => toggle('category', 'Full Lace Wigs')}/> <span>Full Lace Wigs</span></li>
          <li><input type="radio" name="cat" checked={params.get('category')==='Human Hair Wigs'} onChange={() => toggle('category', 'Human Hair Wigs')}/> <span>Human Hair Wigs</span></li>
          <li><input type="radio" name="cat" checked={params.get('category')==='Lace Front Wigs'} onChange={() => toggle('category', 'Lace Front Wigs')}/> <span>Lace Front Wigs</span></li>
          <li><input type="radio" name="cat" checked={params.get('category')==='Synthetic Wigs'} onChange={() => toggle('category', 'Synthetic Wigs')}/> <span>Synthetic Wigs</span></li>
        </ul>
      </div>

      <div className="ws-filter-group">
        <div className="ws-filter-title">Style</div>
        <ul className="ws-filter-list">
          <li><input type="checkbox" checked={isChecked('style','Straight')} onChange={()=>toggle('style','Straight', true)}/> <span>Straight</span></li>
          <li><input type="checkbox" checked={isChecked('style','Curly')} onChange={()=>toggle('style','Curly', true)}/> <span>Curly</span></li>
          <li><input type="checkbox" checked={isChecked('style','Wavy')} onChange={()=>toggle('style','Wavy', true)}/> <span>Wavy</span></li>
          <li><input type="checkbox" checked={isChecked('style','Body Wave')} onChange={()=>toggle('style','Body Wave', true)}/> <span>Body Wave</span></li>
        </ul>
      </div>

      <div className="ws-filter-group">
        <div className="ws-filter-title">Length</div>
        <ul className="ws-filter-list">
          <li><input type="checkbox" checked={isChecked('length','10-12"')} onChange={()=>toggle('length','10-12"', true)}/> <span>10-12"</span></li>
          <li><input type="checkbox" checked={isChecked('length','14-16"')} onChange={()=>toggle('length','14-16"', true)}/> <span>14-16"</span></li>
          <li><input type="checkbox" checked={isChecked('length','18-20"')} onChange={()=>toggle('length','18-20"', true)}/> <span>18-20"</span></li>
          <li><input type="checkbox" checked={isChecked('length','22-24"')} onChange={()=>toggle('length','22-24"', true)}/> <span>22-24"</span></li>
          <li><input type="checkbox" checked={isChecked('length','26"+')} onChange={()=>toggle('length','26"+', true)}/> <span>26"+</span></li>
        </ul>
      </div>

      <div className="ws-filter-group">
        <div className="ws-filter-title">Material</div>
        <ul className="ws-filter-list">
          <li><input type="checkbox" checked={isChecked('material','Human Hair')} onChange={()=>toggle('material','Human Hair', true)}/> <span>Human Hair</span></li>
          <li><input type="checkbox" checked={isChecked('material','Synthetic')} onChange={()=>toggle('material','Synthetic', true)}/> <span>Synthetic</span></li>
          <li><input type="checkbox" checked={isChecked('material','Heat Resistant')} onChange={()=>toggle('material','Heat Resistant', true)}/> <span>Heat Resistant</span></li>
        </ul>
      </div>

      <div className="ws-filter-group">
        <div className="ws-filter-title">Color</div>
        <ul className="ws-filter-list">
          <li><input type="checkbox" checked={isChecked('color','Black')} onChange={()=>toggle('color','Black', true)}/> <span>Black</span></li>
          <li><input type="checkbox" checked={isChecked('color','Brown')} onChange={()=>toggle('color','Brown', true)}/> <span>Brown</span></li>
          <li><input type="checkbox" checked={isChecked('color','Blonde')} onChange={()=>toggle('color','Blonde', true)}/> <span>Blonde</span></li>
          <li><input type="checkbox" checked={isChecked('color','Red')} onChange={()=>toggle('color','Red', true)}/> <span>Red</span></li>
          <li><input type="checkbox" checked={isChecked('color','Grey')} onChange={()=>toggle('color','Grey', true)}/> <span>Grey</span></li>
          <li><input type="checkbox" checked={isChecked('color','Ombre')} onChange={()=>toggle('color','Ombre', true)}/> <span>Ombre</span></li>
        </ul>
      </div>
      <button className="ws-btn ws-btn-outline" onClick={reset}>Reset Filters</button>
    </aside>
  )
}

export default Filters


